module.exports = __webpack_public_path__ + "img/pending.4e337985.png";